module.exports = __webpack_public_path__ + "img/survey-both.f53cd633.png";